var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("personal-details", {
        ref: "personalDetails",
        attrs: {
          "user-details": _vm.userDetails,
          "account-details": _vm.accountDetails,
          portal: "broker",
        },
        on: { "allow-save": _vm.handleAllowSave, submit: _vm.handleSubmit },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }